import React from 'react';

const AlbumInfo = () => {
  return (
    <section id="album-info" className="py-16 bg-gray-800">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-8 text-center">📀 앨범 정보 📀</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* 여기에 앨범 정보를 추가하세요 */}
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/grassgreenpark/", "_blank")}
          >
            <img src="https://ifh.cc/g/1anv3W.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">가끔 내 방에는 바다가 밀려온다</h3>
            <p className="text-gray-300 mb-2">박연두</p>
            <p className="text-gray-400">😊 박연두는 노래하고 글을 쓰는 싱어송라이터야. 그는 삶과 노래가 함께 흘러가고 깊어지기를 꿈꾸는 아티스트지. 

이번에 그가 내놓은 앨범은 정말 소박해. 기타와 목소리, 그리고 방의 소음으로만 채워져 있거든. 하지만 이런 단순함이 오히려 새로운 가능성을 열어주는 것 같아. 노래를 듣다 보면 어느새 네가 바다에 도착한 것 같은 기분을 느낄 수도 있을 거야.

박연두의 노랫말은 바다와 섬에 대한 내밀한 이야기를 담고 있어. 이 가사들은 우리의 내면을 들여다보게 만들기도 하고, 우리가 세상을 살아가는 모습을 비추는 거울 역할을 하기도 해. 

이 앨범은 마치 촘촘하게 짜인 하나의 세계 같아. 그 세계로 너를 초대하고 싶어. 들어보면 네 마음속에 어떤 울림이 생길지 모르겠다. 한번 들어볼래? 
            </p>
          </div>
          {/* 더 많은 앨범 정보 카드를 추가할 수 있습니다 */}
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/sabbaha_kr/", "_blank")}
          >
            <img src="https://ifh.cc/g/XMGAnZ.png" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">Prelude to Ossuary (Single)</h3>
            <p className="text-gray-300 mb-2">Sabbaha</p>
            <p className="text-gray-400">🎶 Sabbaha는 서울과 수원을 중심으로 활동하는 반인반령의 솔로 유닛이야. 슬러지에서 영감을 받아 하이게인 둠 메탈 사운드를 만들고, 운명을 뒤트는 고통을 음악으로 표현하는 걸 주제로 삼고 있어.

이 싱글에서는 납골당으로 가기 전의 분위기를 음악으로 표현했어. 불길한 리듬이 계속 반복되는 구조를 통해 인간이나 신이 아닌 다른 무언가를 위해 울리는 것 같은 신비롭고 초월적인 느낌을 주고 있어.

'Prelude to Ossuary (Single ver.)'라는 한 곡으로만 구성된 이 싱글은 Sabbaha의 음악 스펙트럼을 넓히고 있어. 원래의 하이게인 둠 메탈 스타일에서 벗어나 새로운 시도를 한 작품이라고 볼 수 있지. 이를 통해 아티스트의 음악적 성장을 볼 수 있어.
            </p>
          </div>
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/themilliways_official/", "_blank")}
          >
            <img src="https://ifh.cc/g/4prXjk.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">Ian</h3>
            <p className="text-gray-300 mb-2">themilliways</p>
            <p className="text-gray-400">💔 더 밀리웨이스(본명 주진태)는 다양한 록 장르를 넘나드는 인스트루멘탈 사운드스케이프를 선보이는 음악가야. 밴드 활동과 영상 콘텐츠 디렉터 경험을 쌓은 후 2021년 솔로로 데뷔해 독창적인 음악 세계를 구축해오고 있지. 그의 새 앨범 'Ian'은 아들을 그리워하는 아버지의 마음을 담고 있어. 2017년 폐암 말기 진단 후 이혼과 함께 아들과 헤어진 주진태는 5년간 아들 소식을 듣지 못했어. 2019년 병원에서 마지막으로 본 아들 이안을 향한 그리움과 재회에 대한 희망이 이 작은 앨범에 녹아있지. 'Ian'은 아버지의 사랑과 기다림을 음악으로 표현한 감동적인 작품이야.</p>
          </div>
          <div className="bg-gray-700 p-6 rounded-lg shadow-lg">
            <img src="https://ifh.cc/g/T9Nw8P.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">Panorama</h3>
            <p className="text-gray-300 mb-2">ANAZAO</p>
            <p className="text-gray-400">🌟 ANAZAO(아나자오)는 헬라어로 '돌아오다', '회계하다'라는 뜻을 가진 이름의 아티스트야. 방황하는 삶 속에서 음악으로 돌아와 진정한 꿈을 찾은 경험을 바탕으로, 현실에 낙심한 사람들에게 희망과 힘을 주는 음악을 만들고 있어.

그의 새 앨범 'Panorama'는 미공개 곡들로 구성된 믹스테입이야. 인생의 여정을 되돌아보며 곡을 선정했대. 이 앨범은 우리 삶의 다양한 순간들을 담고 있어 - 불같은 열정으로 달리는 때도 있고, 차갑게 식어 끝나버리는 때도 있지. 때론 지옥 같은 날도 있겠지만, 우리가 계속 꿈을 향해 나아가는 건 약속된 천국을 기대하기 때문이라고 ANAZAO는 말해.

</p>
          </div>
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/nahuamx/", "_blank")}
          >
            <img src="https://ifh.cc/g/4HMpbf.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">Toxcatl</h3>
            <p className="text-gray-300 mb-2">NAHUA</p>
            <p className="text-gray-400">🎸 NAHUA는 서울에 기반을 둔 멕시코 출신 음악가야. 기타와 베이스를 거의 20년 동안 연주해왔고, 피아노는 6년, 화성학은 2년 동안 공부했대. 장르나 스타일에 구애받지 않고 좋고 독특한 음악이라면 모두 좋아한다고 해.
            그의 새 앨범 'Toxcatl'은 아즈텍 문화에서 영감을 받았어. 특히 테스카틀리포카 신을 기리는 고대 의식에서 아이디어를 얻었다고 해. 테스카틀리포카는 아즈텍 신화에서 주요 신 중 하나로, 케찰코아틀만큼 중요한 존재야.</p>
          </div>
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/heewoo_7/", "_blank")}
          >
            <img src="https://ifh.cc/g/d0fQvq.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">희우 베스트</h3>
            <p className="text-gray-300 mb-2">희우</p>
            <p className="text-gray-400">🎤 희우는 소리꾼이면서 싱어송라이터로 활동하고 있어. 국악을 기반으로 한 독특한 리듬과 선율로 자신만의 곡을 만들고 부르는 아티스트지. 그의 음악은 전통과 현대를 아우르는 독특한 감성을 지니고 있어.
그의 새 앨범은 기존 곡의 재해석과 신곡을 함께 담고 있어. 미니앨범 EP '어느새'에 수록됐던 '봄비'의 피아노 버전과 올해 발매된 '그대는'의 피아노 버전이 포함되어 있어. 이 피아노 버전들은 원곡과는 또 다른 분위기를 자아낼 것 같아.
여기에 새롭게 선보이는 신곡 '트라우마'가 더해져 총 세 곡으로 구성된 앨범이야. '트라우마'는 '따끈따끈한' 신곡이라고 하는데, 희우의 최근 음악적 고민과 성장이 담겨 있을 것 같아.</p>
          </div>
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/blackaftermoon/", "_blank")}
          >
            <img src="https://ifh.cc/g/1fZgJF.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">갱도</h3>
            <p className="text-gray-300 mb-2">박치치</p>
            <p className="text-gray-400">📖 박치치는 시인, 음악가, 영화 감독으로 다방면에서 활동하고 있는 아티스트야. 2022년에 첫 번째 시노래집 '발작'을 발표했고, 이번에 2024년 두 번째 시노래집 '갱도'를 선보였어.

'갱도'는 박치치의 예술 세계를 깊이 있게 보여주는 작품이야. 이 앨범은 25편의 시와 5곡의 노래로 구성되어 있어. 

앨범 제목 '갱도'는 어둡고 미로 같은 공간을 연상시키는데, 이는 우리 삶의 어려운 순간들을 상징하는 것 같아. 박치치는 이 앨범을 "먹통같은 갱도에서 엉엉 울며 길 헤메는 모든 시들에게" 바친다고 해. 

특히 주목할 만한 점은 그의 메시지야. "가장 춥고 어두운 밤이 온대도 우리는 선하고 다정하고 진실되기를" 바란다는 말에서, 어려운 상황 속에서도 인간성을 잃지 않기를 희망하는 그의 마음이 느껴져.

이 앨범은 단순한 음악이나 시집을 넘어서, 우리 삶의 어두운 순간들을 헤쳐나가는 여정을 함께 나누고 위로를 건네는 작품으로 보여. 박치치의 다양한 예술적 재능이 어우러져 만들어낸 독특하고 깊이 있는 작품이 될 것 같아.</p>
          </div>
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/podopodopo/", "_blank")}
          >
            <img src="https://ifh.cc/g/Hsqsjm.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">뿌직뿌직</h3>
            <p className="text-gray-300 mb-2">설사소스</p>
            <p className="text-gray-400">💩 향긋한 설사소스가 우리의 귀와 코를 테러하러 올 거야. 이놈들, "한국에서 제일 더럽고 지저분한 음악" 한다고 자랑질이야. 뭐야, 똥 치우는 청소부가 됐다고 으쓱대나?

새 앨범 '뿌직뿌직'은 진짜 귀를 고문하는 걸작이래. "더럽고 의미없는 음악이 쓸데없이 길게 연주"된다니까, 이거 듣다가 설사하면 책임져? 인내심 테스트 하는 줄 알았네.

CD를 음식물 쓰레기 봉지에 담아 판대. 뭐야 이거, 예술이야 실수야? "음식물 쓰레기 봉투 샀더니 CD 끼워줬어요" 라니... 와, 세상에 이렇게 관대한 음반사가 또 어디 있겠어?

설사소스, 이 녀석들 우리한테 인생의 깊은 뜻을 가르치려나 봐. "음반이 똥같아도 최소한 음식물 쓰레기 봉투는 건진다" 래. 야, 이게 바로 똥 속에서 금 찾는 긍정의 철학이지!

자, 이제 다들 설사소스 음악 듣고 인생의 의미 같은 거 고민해볼래? 근데 음악 듣기 전에 화장실 위치부터 체크해. 이 음악이 네 장에 어떤 영감을 줄지 모르니까. 설사 준비 됐어? 그럼 힘차게 뿌직!</p>
          </div>
          <div 
            className="bg-gray-700 p-6 rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer" 
            onClick={() => window.open("https://www.instagram.com/podopodopo/", "_blank")}
          >
            <img src="https://ifh.cc/g/FYbaXq.jpg" alt="앨범 커버" className="w-full h-auto mb-4 rounded" />
            <h3 className="text-xl font-subtitle mb-2">LP 특별할인전</h3>
            <p className="text-gray-300 mb-2">롱플레이어</p>
            <p className="text-gray-400">📀 수원의 음악 애호가들이 사랑하는 명소, 롱플레이어에서 특별한 LP 음반 할인 행사를 열거야. 이번 행사에서는 다양한 장르의 LP 음반들을 특별 할인된 가격으로 만날 수 있대. 클래식부터 재즈, 록, 팝, 트로트까지 폭넓은 선택의 즐거움을 누릴 수 있고, 희귀 음반을 발견할 기회도 있을 거야.
음악을 사랑하는 사람들이라면 이 특별한 기회를 놓치지 말고, 롱플레이어에 한번 가봐. 아날로그 음악의 따뜻한 감성을 만끽할 수 있을 거야. vinyl을 통해 들려오는 음악의 깊이 있는 사운드와 특유의 질감을 직접 경험해볼 수 있대.
롱플레이어의 이번 할인전은 그냥 음반 싸게 파는 행사가 아니라, 음악 좋아하는 사람들이 모여서 서로의 취향을 나누고 새로운 음악적 경험을 할 수 있는 축제 같은 자리가 될 거야. 너희의 음악 컬렉션을 더 풍성하게 만들어줄 이번 할인전에 많이들 와줘!</p>
          </div>
          
          
        </div>
      </div>
    </section>
  );
};

export default AlbumInfo;